import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import { Button, Dialog, DialogTitle, DialogContent, Tooltip, DialogContentText } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { getShduledRoute } from "../../utils/GetPlanning";
import TableAbstraction, { TableAbstractionColumn } from "../../componentUtils/TableAbstraction";
import DateAct from "./DateAct";

interface Inputs {
  open: any;
  onClose: any;
  refresh: any;
  scheduledObj: any;
}

export default function SheduledRoute(props: Inputs) {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateAlert, setdateAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    setState(props.scheduledObj);
    setLoading(false);
  });

  const columns: TableAbstractionColumn[] = [
    {
      label: "Status",
      name: "status",
      options: {
        filter: false,
        searchable: false,
        renderCell: ({ row }) => {
          return (
            <>
              {row.status === "C" ? (
                <Tooltip title="Confirmed">
                  <Button style={{ color: "darkgray" }}>
                    <DoneOutlineIcon />
                  </Button>
                </Tooltip>
              ) : (
                <Tooltip title="Scheduled">
                  <Button color="secondary">
                    <LocalShippingIcon />
                  </Button>
                </Tooltip>
              )}
            </>
          );
        },
      },
    },
    {
      label: "Customer Number",
      name: "customer_num",
    },
    {
      label: "Route",
      name: "route_act",
    },
    {
      label: "Next Delivery",
      name: "visit_dt_plan",
      options: {
        filter: false,
        searchable: false,
        renderCell: ({ row }) => {
          const visitDate = row.visit_dt_plan ? new Date(row.visit_dt_plan).toISOString().split("T")[0] : "";
          return (
            <>
              <div
                style={{
                  borderRadius: "4px",
                  color: "#e9232a",
                }}
              >
                {visitDate}
              </div>
            </>
          );
        },
      },
    },
  ];

  return (
    <>
      <Dialog fullWidth={true} maxWidth="md" aria-labelledby="dri-title" open={props.open} onClose={props.onClose}>
        <div>
          <Button
            onClick={() => props.onClose()}
            color="secondary"
            style={{
              width: "fit-content",
              float: "right",
            }}
          >
            <CloseIcon />
          </Button>
        </div>
        <DialogContent>
          {/* {state.map((item:any,key)=>{
          <li> 
            {item.customer_num}
          </li>
        })} */}
          <div id="schedule-visit">
            <TableAbstraction
              settingsKey="VS_PLN"
              title="Schedule Visit"
              columns={columns}
              data={state}
              loading={loading}
              options={{
                serverSide: false,
                responsive: "standard",
                selectableRows: "none",
                fixedHeader: true,
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={dateAlert} onClose={() => setdateAlert(false)}>
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>Already scheduled for the provided date. Please retry with another date</DialogContentText>
        </DialogContent>
      </Dialog>
      {/* <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop> */}
    </>
  );
}
